var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgMedicalExamination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1229_58985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 2.5V4.16667H5.00004V7.5C5.00004 9.34167 6.49171 10.8333 8.33337 10.8333C10.175 10.8333 11.6667 9.34167 11.6667 7.5V4.16667H10V2.5H12.5C12.96 2.5 13.3334 2.87333 13.3334 3.33333V7.5C13.3334 9.9775 11.5317 12.0333 9.16671 12.4308V13.75C9.16671 15.3608 10.4725 16.6667 12.0834 16.6667C13.3309 16.6667 14.3959 15.8833 14.8125 14.7808C13.94 14.3917 13.3334 13.5167 13.3334 12.5C13.3334 11.1192 14.4525 10 15.8334 10C17.2142 10 18.3334 11.1192 18.3334 12.5C18.3334 13.6425 17.5667 14.6058 16.52 14.9042C16.0084 16.8767 14.2159 18.3333 12.0834 18.3333C9.55171 18.3333 7.50004 16.2817 7.50004 13.75V12.4308C5.13504 12.0342 3.33337 9.9775 3.33337 7.5V3.33333C3.33337 2.87333 3.70671 2.5 4.16671 2.5H6.66671ZM15.8334 11.6667C15.3734 11.6667 15 12.04 15 12.5C15 12.96 15.3734 13.3333 15.8334 13.3333C16.2934 13.3333 16.6667 12.96 16.6667 12.5C16.6667 12.04 16.2934 11.6667 15.8334 11.6667Z",
    fill: "#002244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_58985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgMedicalExamination);
export default __webpack_public_path__ + "static/media/svg_medical_examination.40a81b061514acd89aeeb7129e2ad589.svg";
export { ForwardRef as ReactComponent };